import React, { useEffect } from 'react'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import Aos from 'aos'
import TestSlider from '../Components/TestSlider';

function Testimonials() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  return (
    <>
      <div className="main-div2">
        <Navbar />
        <h6 className="font-[500] text-center pt-[130px] xl:pb-[56px] mb-[30px] xl:text-[110px] lg:text-[90px] md:text-[70px] text-[40px] xl:leading-[119px] lg:leading-[100px] md:leading-[80px] leading-[50px] text-[#000000]">What Our <span className='italic text-[#6953A3] font-dmserif'>Client Says</span></h6>
        <div className='test-slider'>
          <h6 className='left-title'>
            Testimonials
          </h6>
          <TestSlider />
        </div>
        <Footer />
      </div>
    </>
  )
}

export default Testimonials